import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-6 md:py-8 px-4 bg-brand-dark border-y border-brand-accent/10" data-id="element-71">
      <div className="max-w-2xl mx-auto text-center" data-id="element-72">
        <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-brand-accent rounded-full mb-5 shadow-[0_0_30px_rgba(0,255,136,0.5)]" data-id="element-73">
          <ShieldCheck className="w-8 h-8 md:w-10 md:h-10 text-brand-dark" data-id="element-74" />
        </div>

        <h2 className="text-xl md:text-3xl font-black mb-4 text-brand-accent neon-glow uppercase tracking-tight" data-id="element-75">
          🛡️ GARANTÍA "FILOSOFÍA PRO" — 7 DÍAS
        </h2>

        <div className="text-sm md:text-base font-bold space-y-3 mb-5 text-gray-200 leading-relaxed" data-id="element-76">
          <p data-id="element-77">
            Abrís los 6 tomos. Revisás los 4 bonos. Usalos en tu clase más
            difícil este lunes.
          </p>
          <p className="text-gray-400" data-id="element-78">
            Si el martes sentís que tus alumnos no participaron más, o que el
            material no tiene el rigor que buscabas:
          </p>
          <div className="py-2" data-id="element-79">
            <p className="text-xl md:text-2xl font-black text-brand-dark bg-brand-accent inline-block px-6 py-3 rounded-lg shadow-[0_0_20px_rgba(0,255,136,0.3)] uppercase tracking-wide" data-id="element-80">
              Te devolvemos el 100%
            </p>
          </div>
          <p className="text-gray-500 uppercase tracking-widest text-xs md:text-sm mt-2" data-id="element-81">
            Sin preguntas. Sin formularios. Sin dramas.
          </p>
        </div>
      </div>
    </section>;
}